var attrHide, attrShow, axHide, axShow, axToggleVisiblityState, setPlaceholderState, togglePlaceholderState;

attrShow = {
  'aria-hidden': false,
  'tabindex': 0
};

attrHide = {
  'aria-hidden': true,
  'tabindex': -1
};


/*
 * Toggle visibility class on adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

setPlaceholderState = function($input, action) {
  var $placeholder;
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if ($input.attr('placeholder')) {
    action = 'hide';
  }
  $placeholder = $input.siblings('.ls-flex-placeholder');
  if (!($placeholder != null ? $placeholder.length : void 0)) {
    return;
  }
  switch (action) {
    case 'hide':
      $placeholder.addClass('isHidden');
      break;
    case 'show':
      $placeholder.removeClass('isHidden');
      break;
    default:
      $placeholder.toggleClass('isHidden');
  }
};


/*
 * Wrapper to toggle visibility of adjacent label / placeholder
 *
 * @param {object} $input   - Input jQuery selector
 * @param {string} [action] - Action to add / remove or toggle (default) visibility class (optional)
 */

togglePlaceholderState = function($input, action) {
  if (action == null) {
    action = '';
  }
  if (!($input != null ? $input.length : void 0)) {
    return;
  }
  if (action) {
    setPlaceholderState($input, action);
  } else {
    if ($input.val() === '') {
      setPlaceholderState($input, 'show');
    } else {
      setPlaceholderState($input, 'hide');
    }
  }
};


/*
 * AX - Function to toggle visibility of jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axToggleVisiblityState = function($el, cb) {
  var attr, isHidden;
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  isHidden = $el.attr('aria-hidden') === 'true';
  attr = isHidden ? attrShow : attrHide;
  $el.attr(attr);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to hide jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axHide = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrHide);
  if (typeof cb === "function") {
    cb();
  }
};


/*
 * AX - Function to show jQuery element
 *
 * @param {object} $el  - Element jQuery selector
 * @param {string} [cb] - Callback (optional)
 */

axShow = function($el, cb) {
  if (!($el != null ? $el.length : void 0)) {
    return;
  }
  $el.attr(attrShow);
  if (typeof cb === "function") {
    cb();
  }
};

module.exports = {
  ax: {
    show: axShow,
    hide: axHide,
    toggleVisibility: axToggleVisiblityState
  },
  attrShow: attrShow,
  attrHide: attrHide,
  placeholderState: {
    set: setPlaceholderState,
    toggle: togglePlaceholderState
  }
};

//# sourceMappingURL=data:application/json;base64,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
